var attrHide, attrShow, axHide, axShow, axToggleVisiblityState, setPlaceholderState, togglePlaceholderState;

attrShow = {
  'aria-hidden': false,
  'tabindex': 0
};

attrHide = {
  'aria-hidden': true,
  'tabindex': -1
};


/*
 * Toggle visibility class on adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

setPlaceholderState = function($input, action) {
  var $placeholder;
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if ($input.attr('placeholder')) {
    action = 'hide';
  }
  $placeholder = $input.siblings('.ls-flex-placeholder');
  if (!($placeholder != null ? $placeholder.length : void 0)) {
    return;
  }
  switch (action) {
    case 'hide':
      $placeholder.addClass('isHidden');
      break;
    case 'show':
      $placeholder.removeClass('isHidden');
      break;
    default:
      $placeholder.toggleClass('isHidden');
  }
};


/*
 * Wrapper to toggle visibility of adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

togglePlaceholderState = function($input, action) {
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (action) {
    setPlaceholderState($input, action);
  } else {
    if ($input.val() === '') {
      setPlaceholderState($input, 'show');
    } else {
      setPlaceholderState($input, 'hide');
    }
  }
};


/*
 * AX - Function to toggle visibility of jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axToggleVisiblityState = function($el, cb) {
  var attr, isHidden;
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  isHidden = $el.attr('aria-hidden') === 'true';
  attr = isHidden ? attrShow : attrHide;
  $el.attr(attr);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to hide jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axHide = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrHide);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to show jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axShow = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrShow);
  if (typeof cb === "function") {
    cb();
  }
};

module.exports = {
  ax: {
    show: axShow,
    hide: axHide,
    toggleVisibility: axToggleVisiblityState
  },
  attrShow: attrShow,
  attrHide: attrHide,
  placeholderState: {
    set: setPlaceholderState,
    toggle: togglePlaceholderState
  }
};

//# sourceMappingURL=data:application/json;base64,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
